var attrHide, attrShow, axHide, axShow, axToggleVisiblityState, setPlaceholderState, togglePlaceholderState;

attrShow = {
  'aria-hidden': false,
  'tabindex': 0
};

attrHide = {
  'aria-hidden': true,
  'tabindex': -1
};


/*
 * Toggle visibility class on adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

setPlaceholderState = function($input, action) {
  var $placeholder;
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if ($input.attr('placeholder')) {
    action = 'hide';
  }
  $placeholder = $input.siblings('.ls-flex-placeholder');
  if (!($placeholder != null ? $placeholder.length : void 0)) {
    return;
  }
  switch (action) {
    case 'hide':
      $placeholder.addClass('isHidden');
      break;
    case 'show':
      $placeholder.removeClass('isHidden');
      break;
    default:
      $placeholder.toggleClass('isHidden');
  }
};


/*
 * Wrapper to toggle visibility of adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

togglePlaceholderState = function($input, action) {
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (action) {
    setPlaceholderState($input, action);
  } else {
    if ($input.val() === '') {
      setPlaceholderState($input, 'show');
    } else {
      setPlaceholderState($input, 'hide');
    }
  }
};


/*
 * AX - Function to toggle visibility of jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axToggleVisiblityState = function($el, cb) {
  var attr, isHidden;
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  isHidden = $el.attr('aria-hidden') === 'true';
  attr = isHidden ? attrShow : attrHide;
  $el.attr(attr);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to hide jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axHide = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrHide);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to show jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axShow = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrShow);
  if (typeof cb === "function") {
    cb();
  }
};

module.exports = {
  ax: {
    show: axShow,
    hide: axHide,
    toggleVisibility: axToggleVisiblityState
  },
  attrShow: attrShow,
  attrHide: attrHide,
  placeholderState: {
    set: setPlaceholderState,
    toggle: togglePlaceholderState
  }
};

//# sourceMappingURL=data:application/json;base64,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
